import React from 'react';
import {MoreVert as MoreVertIcon} from '@material-ui/icons';
import {Menu, MenuItem, IconButton} from '@material-ui/core';
import './ContextMenu.scss';

type Child = React.ReactElement | string;

interface ContextMenuProps {
    className?: string;
    children: Child[];
}

const ContextMenu = ({className, children}: ContextMenuProps) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };

    const handleClose = (e: React.MouseEvent) => {
        e.stopPropagation();
        setAnchorEl(null);
    };

    const ITEM_HEIGHT = 48;

    return (
        <div className="context-menu">
            <IconButton
                aria-label="more"
                aria-controls="context-menu"
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="context-menu"
                className={className}
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '80px',
                    },
                }}
            >
                {children.map((child: string | JSX.Element, index: number) => (
                    <MenuItem key={index} onClick={handleClose} className={className}>
                        {child}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

export default ContextMenu;
